import styled from 'styled-components';

const Custom404TemplateStyle = styled.section`
	--marginT: var(--sp2x);
	--marginB: var(--sp4x);
	--textWidth: 20%;

	width: 100%;
	height: calc(100vh - (var(--headerFixedHeight) + var(--headerBannerHeight)));

	.wrapper-content-inner {
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.err-desc {
		width: var(--textWidth);
		margin: var(--marginT) 0 var(--marginB);
		line-height: 150%;
	}

	.btn {
		a {
			font-weight: 400;
			color: var(--neutral1000);
		}
	}

	.wrapper-button-nav {
		display: none;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--textWidth: 28%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--textWidth: 59%;
	}
`;

export default Custom404TemplateStyle;
